module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "default-bg"
  }, [_c('div', {
    staticClass: "flex-bar"
  }, [_c('span', {
    staticClass: "icon-goback",
    attrs: {
      "onClick": "history.back();"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex-right",
    on: {
      "click": function($event) {
        _vm.submitLoading && _vm.cancelSubmit()
      }
    }
  }, [_vm._v("提交")])]), _vm._v(" "), _c('div', {
    staticClass: "reason-sec",
    on: {
      "click": function($event) {
        _vm.popupVisible = true
      }
    }
  }, [_c('span', {
    staticClass: "text-grey"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.reasonText ? _vm.reasonText[0] : '请选择原因') + "\n\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-right"
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('mt-popup', {
    staticClass: "reason-picker",
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.popupVisible),
      callback: function($$v) {
        _vm.popupVisible = $$v
      },
      expression: "popupVisible"
    }
  }, [_c('mt-picker', {
    attrs: {
      "slots": _vm.slots,
      "showToolbar": true,
      "visibleItemCount": 3
    },
    on: {
      "change": _vm.onValuesChange
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.popupVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.checkReason
    }
  }, [_vm._v("确定")])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-title"
  }, [_c('span', {
    staticClass: "vt-middle"
  }, [_vm._v("申请取消订单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cancel-tips"
  }, [_c('p', [_vm._v("当前订单取消后将无法恢复")]), _vm._v(" "), _c('p', [_vm._v("订单若已付金额，退款将原路返回，请注意返回时间。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a38071ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/orderCancel.vue
// module id = 586
// module chunks = 1